import { defineStyleConfig } from "@chakra-ui/react";

const Textarea = defineStyleConfig({
  variants: {
    outline: {
      borderRadius: "var(--chakra-radii-xl)",
      fontSize: "xl",
      _hover: {
        borderColor: "primary.300",
      },
      background: "transparent",
    },
  },
});

export default Textarea;
